import { FiLock, FiDatabase, FiShield } from 'react-icons/fi';
import SectionHeading from './SectionHeading';
import useReveal from './useReveal';

const safeguards = [
  {
    icon: FiLock,
    title: 'Data Encryption',
    text: 'We use advanced encryption algorithms to protect your data from unauthorized access.',
  },
  {
    icon: FiDatabase,
    title: 'Regular Backups',
    text: 'We perform regular backups to ensure that your data is always safe and can be restored if needed.',
  },
  {
    icon: FiShield,
    title: 'Access Control',
    text: 'We implement strict access controls to ensure that only authorized personnel can access your data.',
  },
];

function Security() {
  const ref = useReveal();

  return (
    <div ref={ref} className="section-pad glow-dark">
      <div className="wrap">
        <SectionHeading
          dark
          center
          eyebrow="Security"
          title={<>Your data is <span className="text-gradient">safe with us</span></>}
          lede="We prioritize the security of your information."
        />

        <div className="mt-14 grid gap-5 md:grid-cols-3">
          {safeguards.map(({ icon: Icon, title, text }, index) => (
            <div
              key={title}
              className="reveal card-glass group p-7"
              data-reveal
              style={{ '--d': `${index * 80}ms` }}
            >
              <span className="icon-tile">
                <Icon size={20} />
              </span>
              <h3 className="display-md mt-6 text-white">{title}</h3>
              <p className="mt-3 text-subtle">{text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Security;
